import { defineStore } from "pinia";
import type { DisplayPermission } from "~/core/models/DisplayPermission.enum";
import LxcError from "~/core/models/LxcError.class";
import type { UserSession } from "~/modules/user/models/UserSession.interface";
import userService from "~/modules/user/services/user.service";
import { logout } from "~/utils/auth.utils";

export const useUserSession = defineStore("userSession", () => {
  const userSession: Ref<UserSession | undefined> = ref();

  const isAuthenticated = ref(false);

  /**
   * Apply retrieve current user to store
   * @param route
   */
  async function setCurrentUser(): Promise<void> {
    const response = await userService.getCurrentUser();

    if (LxcError.check(response)) {
      logout();
    } else {
      userSession.value = response;

      isAuthenticated.value =
        !!userSession.value?.login && userSession.value?.active;

      // Add the permissions of the user to entity for more convenience to restore permissions
      userSession.value.entity.permissions = userSession.value.permissions;
    }
  }

  function setCurrentUserPermissions(permissions: DisplayPermission[]) {
    if (userSession.value) {
      userSession.value.permissions = permissions;
    }
  }

  return {
    userSession,
    setCurrentUser,
    setCurrentUserPermissions,
    isAuthenticated,
  };
});
